<template>
  <a-modal
    width="650px"
    :title="modal.title"
    v-model:visible="modal.visible"
    :afterClose="close"
    :confirm-loading="modal.confirmLoading"
  >
    <div class="paragraph-title">基本信息</div>
    <a-form
      ref="formRef"
      :model="taskForm"
      :rules="taskFormRules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-item ref="name" label="任务名称" name="name">
        <a-input
          v-model:value="taskForm.name"
          :maxlength="100"
          autocomplete="off"
        />
      </a-form-item>
      <a-form-item label="任务类型" name="type">
        <a-select
          @change="resetEstimate"
          v-model:value="taskForm.type"
          :options="taskTypeOpt"
        >
        </a-select>
      </a-form-item>
      <a-form-item v-if="!isOther" label="数据集" name="datasetId">
        <a-select v-model:value="taskForm.datasetId" @popupScroll="loadDataset">
          <a-select-option
            v-for="item in dataSet.list"
            :key="item.id"
            :addition="item.addition"
            :disabled="item.dataCount == 0"
          >
            {{ item.chineseInstructions }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <div v-if="isOther">
        <a-form-item label="数据集" name="filePath">
          <a-button class="mb10" @click="pathChooseClick">选择文件</a-button>
          <a-alert
            style="position: absolute; top: 0; left: 100px; padding: 4px 10px"
            message="文件夹下不可有多层级目录!"
            type="warning"
          />
          <div>
            <a-input
              class="mr10"
              disabled
              v-model:value="taskForm.filePath"
              autocomplete="off"
            />
          </div>
        </a-form-item>
      </div>

      <div style="position: relative">
        <a-form-item
          v-for="(item, index) in taskForm.estimate"
          :key="item.key"
          v-bind="index === 0 ? {} : formItemLayout"
          :label="index === 0 ? '预估数量' : ''"
          :prop="'item.' + index + '.num'"
          :rules="{
            required: true,
            message: '域名不能为空',
            trigger: 'blur',
          }"
          :name="['estimate', index, 'num']"
        >
          <a-input
            class="mr10"
            style="width: 120px"
            v-model:value="item.num"
            :maxlength="100"
            autocomplete="off"
          />
          <a-select v-model:value="item.unit" style="width: 70px">
            <a-select-option value="个">个</a-select-option>
            <a-select-option value="框">框</a-select-option>
          </a-select>

          <span
            v-if="taskForm.estimate.length > 1"
            @click="delEstimate(index)"
            class="ml10"
            style="color: red; cursor: pointer"
            >删除</span
          >
        </a-form-item>
        <a-form-item v-bind="formItemLayoutWithOutLabel">
          <a-button @click="addNum" type="dashed" style="width: 40%">
            添加+
          </a-button>
          <a-button
            v-if="false"
            @click="finishedEstimate"
            class="ml10"
            type="primary"
            style="width: 40%"
          >
            完成
          </a-button>
        </a-form-item>

        <div style="position: absolute; left: 20px; top: 5px">
          <a-tooltip placement="bottom">
            <template #title>
              <span>用于预估标注价格，具体单位请咨询采购</span>
            </template>
            <span
              style="
                width: 20px;
                height: 20px;
                background: #203873;
                line-height: 20px;
                display: block;
                text-align: center;
                overflow: hidden;
                color: #fff;
                border: 1px solid #203873;
                border-radius: 100%;
              "
              >?</span
            >
          </a-tooltip>
        </div>
      </div>

      <div>
        <a-form-item
          v-if="taskForm.type == 'tag'"
          label="筛选说明"
          name="descriptionLink"
        >
          <a-upload
            v-model:file-list="upload.fileList"
            name="file"
            :action="upload.action"
            :headers="upload.headers"
            @change="uploadchange"
          >
            <a-button>
              <upload-outlined></upload-outlined>
              上传说明
            </a-button>
          </a-upload>
          <!-- <a-input v-model:value="data.taskForm.descriptionLink" placeholder="1~24个字符，可包含大小写字母、数字、中文、下划线" autocomplete="off"/> -->
        </a-form-item>

        <a-form-item v-else label="标注说明" name="descriptionLink">
          <a-upload
            v-model:file-list="upload.fileList"
            name="file"
            :action="upload.action"
            :headers="upload.headers"
            @change="uploadchange"
          >
            <a-button>
              <upload-outlined></upload-outlined>
              上传说明
            </a-button>
          </a-upload>
          <!-- <a-input v-model:value="data.taskForm.descriptionLink" placeholder="1~24个字符，可包含大小写字母、数字、中文、下划线" autocomplete="off"/> -->
        </a-form-item>

        <a-form-item
          v-if="taskForm.type == 'tag'"
          ref="name"
          label="筛选标签"
          name="tags"
        >
          <a-input
            style="width: 200px"
            v-model:value="taskForm.inpLabel"
            :maxlength="100"
            autocomplete="off"
          /><a-button
            style="color: cadetblue"
            @click="labelAdd"
            type="text"
            class="ml10"
            >添加</a-button
          >
          <div>
            <a-tag
              class="mt10"
              closable
              @close="labelColse(index)"
              v-for="(tag, index) in taskForm.tags"
              :key="tag"
              >{{ tag }}</a-tag
            >
          </div>
        </a-form-item>
        <a-form-item
          v-if="!isOther"
          label="初验比例"
          name="spotCheckProportion"
        >
          <a-input-number
            class="mr10"
            id="inputNumber"
            v-model:value="taskForm.spotCheckProportion"
            :min="1"
            :max="100"
          />%
          <a-tooltip>
            <template #title
              >初验阶段，根据设置的百分比，抽取一定比例数据进行初验，范围在1~100之，100为全验</template
            >
            <span
              style="
                display: inline-block;
                width: 20px;
                height: 20px;
                margin-left: -220px;
                text-align: center;
                background-color: #0c2366;
                line-height: 20px;
                border-radius: 50%;
                border: 1px solid #ccc;
                color: #fff;
              "
              >?</span
            >
          </a-tooltip>
          <!-- (初验阶段，根据设置的百分比，抽取一定比例数据进行初验，范围在1~100之，100为全验) -->
        </a-form-item>
        <!-- <a-form-item label="采购经理" name="purchaseManagerId">
          <a-select
            v-model:value="taskForm.purchaseManagerId"
          >
            <a-select-option v-for="item in purchaseManager.list" :key="item.userId">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item> -->
      </div>

      <a-form-item label="要求完成时间" name="endTime">
        <a-date-picker
          :show-time="{ format: 'HH:mm:ss' }"
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
          v-model:value="taskForm.endTime"
        />
      </a-form-item>
      <a-form-item label="说明" name="description">
        <a-textarea v-model:value="taskForm.description" :row="4" />
        <a-alert
          style="margin-top: 5px; padding: 0 auto"
          message="提交表单时，预估数量会自动追加至说明内容中"
          type="warning"
        />
      </a-form-item>
      <a-form-item v-if="isOther" label="" name="bk" style="margin-left: 125px">
        <div style="width: 450px">
          <a-alert
            message="采购经理需要联系运营团队获取，或者看飞书审批确认。"
            type="warning"
          />
        </div>
      </a-form-item>

      <div class="paragraph-title">项目信息</div>
      <a-form-item label="所属项目" name="projectNumber">
        <!--   @search="(val)=>{getProject(val)}" -->
        <a-select
          show-search
          :filter-option="filterOption"
          v-model:value="taskForm.projectNumber"
          @change="chooseProject"
        >
          <a-select-option
            v-for="item in project.list"
            :label="item.projectName"
            :key="item.projectNumber"
            :value="item.projectNumber"
          >
            {{ item.projectName }}
          </a-select-option>
        </a-select>
        <div class="itemInfo" v-show="project.cur.projectNumber">
          <dl>
            <dt>项目编号：</dt>
            <dd>{{ project.cur.projectNumber }}</dd>
          </dl>
          <dl>
            <dt>项目名称：</dt>
            <dd>{{ project.cur.projectName }}</dd>
          </dl>
          <dl>
            <dt>项目经理：</dt>
            <dd>{{ project.cur.projectManager }}</dd>
          </dl>
        </div>
      </a-form-item>
      <!-- <a-form-item v-if="!isOther" label="PMO" name="pmoIds">
        <a-select v-model:value="taskForm.pmoIds">
          <a-select-option v-for="item in pmoData.list" :value="item.userId" :key="item.userId">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item> -->

      <a-form-item label="标注方式" name="labelType">
        <a-select
          :disabled="taskForm.type == 'tag'"
          v-model:value="taskForm.labelType"
        >
          <a-select-option value="online" :disabled="isOther"
            >线上</a-select-option
          >
          <a-select-option value="offline">线下</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="标注公司" name="annotationCompanyId">
        <a-input
          v-model:value="taskForm.annotationCompanyId"
          placeholder="请在提交任务后，让项目经理与采购经理协商后在飞书审批完善"
          disabled
          autocomplete="off"
        />
        <!-- <a-select
          v-model:value="data.taskForm.annotationCompanyId"
        >
          <a-select-option v-for="item in data.companyList"
                           :key="item.id">
            {{ item.name }}
          </a-select-option>

        </a-select> -->
      </a-form-item>
      <a-form-item label="预估费用" name="estimatedCost">
        <a-input
          v-model:value="taskForm.estimatedCost"
          placeholder="请在提交任务后，让项目经理与采购经理协商后在飞书审批完善"
          disabled
          autocomplete="off"
        />
      </a-form-item>

      <!-- <div class="paragraph-title">
        任务信息
      </div>
      <a-form-item label="状态" name="estimatedCost">
        <a-input v-model:value="data.taskForm.estimatedCost" placeholder="待采购经理确定完善" disabled autocomplete="off"/>
      </a-form-item> -->
    </a-form>
    <template v-slot:footer>
      <a-button key="back" @click="handleCancel">取消</a-button>
      <a-button
        :loading="modal.confirmLoading"
        key="submit"
        type="primary"
        @click="handleOk"
        >创建</a-button
      >
    </template>
  </a-modal>
  <path-choose @update="setPath" ref="pc"></path-choose>
</template>
<script>
import { message } from "ant-design-vue";
import { publicConfig } from "@/publicConfig";
import {
  ref,
  reactive,
  watch,
  onMounted,
  computed,
  getCurrentInstance,
} from "vue";
import { useStore } from "@/store/index2";
import { UploadOutlined } from "@ant-design/icons-vue";
import { getAllData } from "@/api/dataSet";
import {
  purchaseManagers,
  projects,
  pmos,
  createTask,
  labelTaskEdit,
} from "@/api/taskRelease";

import PathChoose from "./pathChoose.vue";

export default {
  components: {
    UploadOutlined,
    PathChoose,
  },
  props: ["show", "taskData", "fromType"],
  data() {
    return {
      formItemLayout: {
        // labelCol: {
        //   xs: {
        //     span: 24,
        //   },
        //   sm: {
        //     span: 4,
        //   },
        // },
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 20,
            offset: 5,
          },
        },
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 20,
            offset: 5,
          },
        },
      },
    };
  },
  computed: {
    isOther() {
      let takType = this.taskForm.type;
      return takType == "box3d" || takType == "video" || takType == "other";
    },
  },

  watch: {
    isOther: {
      handler(val) {
        if (val) {
          this.taskForm.labelType = "offline";
        }
      },
    },
  },
  emits: ["close", "update"],
  methods: {
    addNum() {
      this.taskForm.estimate.push({
        key: Date.now(),
        num: "",
        unit: "个",
      });
    },
    delEstimate(index) {
      this.taskForm.estimate.splice(index, 1);
    },
    finishedEstimate() {
      let str = "";
      this.taskForm.estimate.join("");
      this.taskForm.estimate.forEach((item) => {
        str += `${item.num}${item.unit}\n`;
      });

      //this.taskForm.description.replace(str,'')

      this.taskForm.description += str;
    },
    resetEstimate() {
      // this.taskForm.estimate = []
      // this.taskForm.description = ''
    },

    pathChooseClick() {
      this.$refs.pc.open();
    },
    setPath(val) {
      this.taskForm.filePath = val;
      debugger;
      this.$forceUpdate();
    },

    filterOption(input, option) {
      if (!input) return false;
      const label = option.label?.toLowerCase();
      const value = option.value?.toLowerCase();
      return label?.includes(input) || value?.includes(input);
    },
  },
  setup(props, context) {
    console.log("formRef");
    const formRef = ref();
    console.log(formRef.value);

    let instance = getCurrentInstance();

    /* 弹框交互    */
    let modal = reactive({
      visible: props.show,
      title: "创建任务",
      type: "creat",
      confirmLoading: false,
    });

    function handleCancel() {
      modal.visible = false;
    }

    function close() {
      context.emit("close");
    }

    let store = useStore();
    let taskTypeOpt = store.taskTypeOpt; //任务类型下拉

    /*   数据集下拉处理     */
    // 数据集的依赖数据
    let dataSet = reactive({
      list: [],
      page: {
        pageNum: 1,
        pageSize: 30,
      },
      more: false,
    });

    //获取数据集
    function getDataMap() {
      getAllData({
        ...dataSet.page,
        parentId: "nullValue",
        field: "createTime",
        order: "desc",
      }).then(({ data: res }) => {
        const arr = dataSet.list;
        dataSet.list = arr.concat(res.map.data.rows);

        if (dataSet.list.length <= res.map.data.total) {
          dataSet.more = true;
        } else {
          dataSet.more = false;
        }
      });
    }

    //数据集滚动事件
    function loadDataset(e) {
      if (
        e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight <
          10 &&
        dataSet.more
      ) {
        const num = dataSet.page.pageNum;
        dataSet.page.pageNum = num + 1;
        getDataMap();
      }
    }

    /*   标注说明上传处理  */
    const token = localStorage.getItem("westToken");
    let upload = reactive({
      action: publicConfig.requestUrl + "/system/api/file/upload",
      headers: { Authorization: "bearer " + token }, //Cookies.get('access_token')
      fileList: [],
    });

    function uploadchange(info) {
      console.log("uploadchange");
      console.log(info.fileList);
      debugger;
      if (info.fileList[0].name && !info.fileList[0].size) {
        const response = info.fileList[1].response;
        if (response && !response.data) {
          message.error(info.fileList[2].response.message);
          upload.fileList = [];
          return;
        }
        if (response && response.data && response.code == 0) {
          message.success("上传完成");
          taskForm.descriptionLink = response.data.url;
          if (upload.fileList.length > 1) {
            upload.fileList = upload.fileList.splice(1, 1);
          }
        }
      } else {
        const response = info.fileList[0].response;
        if (response && !response.data) {
          message.error(info.fileList[1].response.message);
          upload.fileList = [];
          return;
        }
        if (response && response.data && response.code == 0) {
          message.success("上传完成");
          taskForm.descriptionLink = response.data.url;
          if (upload.fileList.length > 1) {
            upload.fileList = upload.fileList.splice(1, 1);
          }
        }
      }
    }

    /*   采购经理下拉处理  */
    let purchaseManager = reactive({
      list: [],
    });

    function getPurchaseManager() {
      purchaseManagers().then(({ data: res }) => {
        purchaseManager.list = res.data;
      });
    }

    let project = reactive({
      list: [],
      cur: {},
      hasProjectManager: computed(() => {
        return project.cur.projectManager ? true : false;
      }),
    });

    /*   所属项目下拉处理    */
    function getProject(keywords) {
      let params = {
        keyWord: keywords,
      };
      projects(params).then(({ data: res }) => {
        project.list = res.data.filter((item) => {
          return item.status === "进行中";
        });
        if (props.taskData && props.fromType == "edit") {
          chooseProject(props.taskData.projectNumber);
        }
      });
    }

    function chooseProject(value) {
      debugger;
      let tmp = project.list.filter((item) => {
        return item.projectNumber == value;
      });
      project.cur = tmp[0];
    }

    let pmoData = reactive({
      list: [],
    });

    /*   所属项目下拉处理    */
    function getPmos() {
      pmos().then(({ data: res }) => {
        pmoData.list = res.data;
      });
    }

    const taskFormRules = {
      name: [
        {
          required: true,
          message: "任务名称不能为空",
          trigger: "blur",
        },
      ],
      type: [
        {
          required: true,
          message: "请选择任务类型",
          trigger: "change",
        },
      ],
      datasetId: [
        {
          required: true,
          message: "请选择数据集",
          trigger: "change",
        },
      ],
      filePath: [
        {
          required: true,
          message: "请选择目录",
          trigger: "blur",
        },
      ],
      descriptionLink: [
        {
          required: true,
          message: "请上传标注说明",
          trigger: "change",
        },
      ],
      spotCheckProportion: [
        {
          required: true,
          message: "初验比例不能为空",
          trigger: "blur",
          type: "number",
        },
      ],
      endTime: [
        {
          required: true,
          message: "完成时间不能为空",
          trigger: "change",
          type: "date",
        },
      ],
      description: [
        {
          required: true,
          message: "说明不能为空",
          trigger: "blur",
        },
      ],
      purchaseManagerId: [
        {
          required: true,
          message: "请选择采购经理",
          trigger: "change",
        },
      ],
      projectNumber: [
        {
          required: true,
          message: "请选择所属项目",
          trigger: "change",
        },
      ],
      pmoIds: [
        {
          required: true,
          message: "请选择PMO",
          trigger: "change",
        },
      ],

      // region: [
      //   {
      //     required: true,
      //     message: 'Please select Activity zone',
      //     trigger: 'change',
      //   },
      // ],
      // date1: [
      //   {
      //     required: true,
      //     message: 'Please pick a date',
      //     trigger: 'change',
      //     type: 'object',
      //   },
      // ],
      // type: [
      //   {
      //     type: 'array',
      //     required: true,
      //     message: 'Please select at least one activity type',
      //     trigger: 'change',
      //   },
      // ]
    };

    /*  创建看任务   */
    // 任务表单
    let taskForm = reactive({
      annotationCompanyId: "", //标注公司
      datasetId: "", //数据集Id
      description: "",
      descriptionLink: "", //标注说明地址
      endTime: "", //  // const time = '2020-05-12T10:23:29'
      estimatedCost: "", //预估费用
      //id:'',

      tags: [],

      name: "",
      projectNumber: "", //项目编号
      //pmoIds:'',
      //purchaseManagerId:'',  //采购经理id
      spotCheckProportion: "", //初验比例
      type: "box2d",
      labelType: "online",
      filePath: "",
      estimate: [
        {
          key: Date.now(),
          num: "",
          unit: "个",
        },
      ],
      //visibility:'',
    });

    function labelColse(index) {
      taskForm.tags.splice(index, 1);
    }

    function labelAdd() {
      if (taskForm.inpLabel) {
        let lebels = taskForm.inpLabel?.split(",");
        let setArr = new Set(taskForm.tags.concat(lebels));
        taskForm.tags = [...setArr];
      }
    }

    watch(
      () => taskForm.type,
      (newValue, oldValue) => {
        if (newValue == "tag") {
          taskForm.labelType = "online";
        }
      }
    );

    function handleOk() {
      formRef.value.validate().then(async () => {
        let str = "";
        taskForm.estimate.join("");
        taskForm.estimate.forEach((item) => {
          str += `${item.num}${item.unit}\n`;
        });

        taskForm.description = str + taskForm.description;

        let westCurrentRole = localStorage.getItem("westCurrentRole");
        if (westCurrentRole) {
          taskForm.groupId = JSON.parse(
            localStorage.getItem("westCurrentRole")
          ).teamId;
        } else {
          message.warning("团队不能为空");
          return;
        }

        if (!project.hasProjectManager) {
          message.error("请前往Erp系统完善项目经理信息后重试！");
          return;
        }

        if (!taskForm?.tags?.length && taskForm.type == "tag") {
          message.error("筛选标签不能为空！");
          return;
        }

        modal.confirmLoading = true;

        if (modal.type == "creat") {
          let data = {
            ...taskForm,
          };

          if (!taskForm?.tags?.length) {
            delete data.tags;
          }

          const { data: res } = await createTask(data);
          console.log(res);
          if (res.code == 0) {
            message.success("创建成功");
            context.emit("update");
            close();
          } else {
            message.error(res.msg);
          }
        } else {
          let data = {
            ...taskForm,
          };

          if (!taskForm?.tags?.length) {
            delete data.tags;
          }

          const { data: res } = await labelTaskEdit(data);
          console.log(res);
          if (res.code == 0) {
            message.success("修改成功");
            context.emit("update");
            close();
          }
        }

        modal.confirmLoading = false;
      });
    }

    onMounted(() => {
      if (props.taskData && props.fromType == "edit") {
        //taskForm = props.taskData
        modal.title = "编辑任务";
        modal.type = "edit";

        taskForm.id = props.taskData.id;
        taskForm.name = props.taskData.name;
        taskForm.type = props.taskData.type;
        taskForm.datasetId = props.taskData.datasetId;
        taskForm.filePath = props.taskData.filePath;

        taskForm.tags = props.taskData.tags;

        taskForm.descriptionLink = props.taskData.descriptionLink;
        taskForm.spotCheckProportion = props.taskData.spotCheckProportion;
        taskForm.endTime = props.taskData.endTime;

        taskForm.description = props.taskData.description;

        taskForm.labelType = props.taskData.labelType;
        taskForm.purchaseManagerId = props.taskData.purchaseManagerId;
        taskForm.projectNumber = props.taskData.projectNumber;
        // taskForm.pmoIds = props.taskData.pmoIds[0]  // 此处若修改为多选时  需调整

        let descriptionLink = props.taskData.descriptionLink;
        let fileNamePos = descriptionLink.lastIndexOf("/");
        let fileName = descriptionLink.slice(
          fileNamePos + 1,
          descriptionLink.length
        );
        upload.fileList[0] = {
          name: fileName,
          //:props.taskData.descriptionLink,
        };

        //name = publicConfig.requestUrl + props.taskData.descriptionLink + '?token=' + token
      } else {
        if (taskForm.id) {
          delete taskForm.id;
        }
        modal.title = "创建任务";
        modal.type = "creat";
      }

      getDataMap();
      getPurchaseManager();
      getProject();
      getPmos();
    });

    return {
      props,
      taskTypeOpt,
      modal,
      handleCancel,
      close,
      dataSet,
      getDataMap,
      loadDataset,
      upload,
      uploadchange,
      purchaseManager,
      getPurchaseManager,
      project,
      chooseProject,
      pmoData,
      getPmos,
      taskFormRules,
      formRef,
      taskForm,
      labelColse,
      labelAdd,
      handleOk,
    };
  },
};
</script>
<style lang="less">
.select_he {
  height: 150px;
  overflow-y: auto;
}
// .rc-virtual-list-holder-inner{
//   max-height: 200px;
//   overflow: auto;
// }
.itemInfo {
  border: 1px solid #ccc;
  padding: 15px;
  margin-top: 5px;
  dl {
    display: flex;
    align-items: center;
    height: 25px;
    dt {
      margin-right: 5px;
    }
    dd {
      margin-top: 7px;
    }
  }
}
</style>
